"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function Catch(_a) {
    var render = _a.render, _b = _a.onError, onError = _b === void 0 ? function () { return ''; } : _b;
    var comp;
    try {
        comp = render();
    }
    catch (e) {
        onError(e);
        comp = React.createElement("span", null);
    }
    return comp;
}
exports.Catch = Catch;
//# sourceMappingURL=Catch.js.map